import styled from 'styled-components/native';
import theme from '../../global/styles/theme';

// interfaces
interface TextProps {
  size?: string;
  font?: string;
  color?: string;
  appTheme: 'light' | 'dark';
}

interface ContainerProps {
  width?: string;
  height?: number;
  marginTop?: number;
  Icon?: any;
  hideBorder?: boolean;
  appTheme: 'light' | 'dark';
}

export const Container = styled.View<ContainerProps>`
  width: ${({width}) => width || 'auto'};
  margin-top: ${({marginTop}) => (marginTop ? `${marginTop}px` : '0px')};
  height: auto;
  z-index: 40;
`;

export const InputArea = styled.View<ContainerProps>`
  border-style: solid;
  border-radius: 6px;
  background-color: ${({appTheme}) =>
    theme.colors(appTheme).backgroundInput};
  padding-left: 10px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: ${({hideBorder, appTheme}) =>
    `${hideBorder ? '0px' : '1px'} solid ${theme.colors(appTheme).gray[150]}`};
  height: ${({height}) => (height ? `${height}px` : '50px')};
  padding-right: 20px;
  z-index: 5;
`;

export const Text = styled.Text<TextProps>`
  font-size: ${({ size}) => size || theme.fonts.size[14]};
  font-family: ${({ font}) =>
    font || theme.fonts.family.opensans.regular};
  color: ${({ color, appTheme}) =>
    color || theme.colors(appTheme).gray[500]};
  margin-bottom: 6px;
`;

export const TextInput = styled.TextInput<ContainerProps>`
  color: ${({ appTheme}) => theme.colors(appTheme).white};
  height: ${({height}) => (height ? `${height}px` : '50px')};
  font-size: 14px;
  font-family: ${({ hideBorder}) =>
    hideBorder
      ? theme.fonts.family.opensans.regular
      : theme.fonts.family.opensans.regular};
  margin-left: ${({Icon}) => (Icon ? '10px' : '0px')};
  /* padding-bottom: 0px; */
  /* padding-top: 4px; */
  flex: 1;
`;

export const ErrorText = styled.Text<ContainerProps>`
  color: ${({ appTheme}) => theme.colors(appTheme).red[500]};
  font-size: ${({theme}) => theme.fonts.size[10]};
  font-family: ${({ hideBorder}) =>
    hideBorder
      ? theme.fonts.family.opensans.regular
      : theme.fonts.family.opensans.regular};
`;

export const HideButton = styled.TouchableOpacity``;

export const DropdownContainer = styled.View<ContainerProps>`
  background-color: ${({ appTheme}) =>
    theme.colors(appTheme).backgroundInput};
  border-radius: 6px;
`;

export const DropdownArea = styled.TouchableOpacity<ContainerProps>`
  width: 100%;
  background-color: ${({ appTheme}) =>
    theme.colors(appTheme).backgroundInput};
  border: ${({ hideBorder, appTheme}) =>
    `${hideBorder ? '0px' : '1px'} solid ${theme.colors(appTheme).gray[800]}`};
  border-radius: 6px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: ${({height}) => (height ? `${height}px` : '50px')};
  padding: 0px 10px;
`;

export const DropdownListArea = styled.View<ContainerProps>`
  max-height: 150px;
  width: 100%;
  justify-content: center;
  border: ${({ hideBorder, appTheme}) =>
    `${hideBorder ? '0px' : '1px'} solid ${theme.colors(appTheme).gray[150]}`};
  padding: 0px 12px;
`;

export const DropdownOptions = styled.TouchableOpacity`
  height: 40px;
  justify-content: center;
`;

export const DropdownList = styled.ScrollView`
  max-height: 150px;
`;
